import React, { useEffect, useState } from "react";
import resourceRest from "../../rest/resourceRest";
export const VersionContext = React.createContext();

export const VersionProvider = props => {

    const [appVersion, setAppVersion] = useState();

    useEffect(() => {
        refresh();
    }, []);

    const refresh = async () => {
        const version = await resourceRest.getAppVersion();
        setAppVersion(version);
    };

    return (
        <VersionContext.Provider value={{
            appVersion,
        }}>
            {props.children}
        </VersionContext.Provider>
    );
};
